import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarFull } from '../TopBarFull';
import {
  TopBarFullCtaColors,
  TopBarFullUseCaseEnums,
} from '../TopBarFullEnums';
import feedbackImage from '../assets/UCS_Event_Feedback.png';

const DEFAULT_UTSOURCE2 = 'full_misc_upsell_event_feedback';
const DEFAULT_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseEventFeedbackTopBarFull.headline',
    defaultMessage: 'Accept payments with your event surveys',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseEventFeedbackTopBarFull.message',
    defaultMessage:
      'Let respondents pay for tickets or donate to charity along with their survey responses.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseEventFeedbackTopBarFull.ctaText',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const INITIATED_DRAFTED_UTSOURCE2 = 'full_initiate_upsell_event_feedback';
const INITIATED_DRAFTED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseEventFeedbackTopBarFull.headlineInitiated',
    defaultMessage: 'Accept payments with your event surveys',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseEventFeedbackTopBarFull.messageInitiated',
    defaultMessage:
      'Let respondents pay for tickets or donate to charity along with their survey responses.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseEventFeedbackTopBarFull.ctaTextInitiated',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const TESTED_ACTIVATED_UTSOURCE2 = 'full_activate_upsell_event_feedback';
const TESTED_ACTIVATED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseEventFeedbackTopBarFull.headlineTested',
    defaultMessage: 'Integrate feedback with your business systems',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseEventFeedbackTopBarFull.messageTested',
    defaultMessage:
      'See your event survey data where you already work with a host of SurveyMonkey integrations.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseEventFeedbackTopBarFull.ctaTextTested',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const DEPLOYED_UTSOURCE2 = 'full_deploy_upsell_event_feedback';
const DEPLOYED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCaseEventFeedbackTopBarFull.headlineDeployed',
    defaultMessage: 'Export and print results to share with your boss',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCaseEventFeedbackTopBarFull.messageDeployed',
    defaultMessage:
      'Present a report of your survey results with advanced exports and printing.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCaseEventFeedbackTopBarFull.ctaTextDeployed',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

export type UseCaseEventFeedbackTopBarFullProps = {
  variation?: TopBarFullUseCaseEnums | null;
};

const VariationToCopy = {
  [TopBarFullUseCaseEnums.InitiatedDrafted]: {
    copy: INITIATED_DRAFTED_COPY,
    utSource2: INITIATED_DRAFTED_UTSOURCE2,
  },
  [TopBarFullUseCaseEnums.TestedActivated]: {
    copy: TESTED_ACTIVATED_COPY,
    utSource2: TESTED_ACTIVATED_UTSOURCE2,
  },
  [TopBarFullUseCaseEnums.Deployed]: {
    copy: DEPLOYED_COPY,
    utSource2: DEPLOYED_UTSOURCE2,
  },
};

export const UseCaseEventFeedbackTopBarFull: React.FC<UseCaseEventFeedbackTopBarFullProps> = ({
  variation, //TODO: get this data.
}) => {
  const [copy, utSource2] =
    variation && variation in VariationToCopy
      ? [VariationToCopy[variation].copy, VariationToCopy[variation].utSource2]
      : [DEFAULT_COPY, DEFAULT_UTSOURCE2];
  return (
    <TopBarFull
      headline={t(copy.HEADLINE)}
      message={t(copy.MESSAGE)}
      image={() => <img src={feedbackImage} aria-hidden="true" />}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL(`/pricing/upgrade`, {
        ut_source: 'topbar',
        ut_source2: utSource2,
      })}
      ctaNewTab={true}
      ctaColor={TopBarFullCtaColors.alt}
    />
  );
};

export default UseCaseEventFeedbackTopBarFull;
